import * as React from 'react';
import moment from 'moment';
import { Translate } from '../../components/Translate';
import { useSync } from '../../data/syncHooks';
import { SyncAsOf } from '../SyncAsOf';

export function UpToDateAsOf() {
  const { isDownloading, lastSuccessfulDownloadDate } = useSync()

  const formattedDate = lastSuccessfulDownloadDate ? moment(lastSuccessfulDownloadDate).format('MMM D, h:mma') : 'Never'

  return (
    <SyncAsOf isSyncing={isDownloading}>
      {isDownloading ? <Translate text={'Syncing...'} /> : <Translate text={'Up to date as of {formattedDate}'} values={{ formattedDate }} />}
    </SyncAsOf>
  )
}
